module.exports = __webpack_public_path__ + "img/TEAM_INFO.bb60f316.svg";